module.exports = __webpack_public_path__ + "static/media/sprite.18def950.svg";